const WORDS = ["Mide", "Registra", "Cumple"];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {Array.from({ length: 4 }).map((_, i) =>
      WORDS.map((word, j) => (
        <span key={`${i}-${j}`} className="flex items-center">
          <span
            className={`whitespace-nowrap px-8 text-5xl font-extrabold uppercase tracking-tight md:text-7xl ${
              j % 2 === 0 ? "text-[#F3EBD7]" : "text-transparent [-webkit-text-stroke:1.5px_#C6F04A]"
            }`}
          >
            {word}
          </span>
          <span className="h-3 w-3 rounded-full bg-[#C6F04A]" />
        </span>
      ))
    )}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" className="overflow-hidden border-y border-[#C6F04A]/20 bg-[#0F4D3F] py-8 md:py-10">
    <div className="animate-marquee flex w-max">
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </section>
);
